import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';

export default function MasterPrivateClassesSwitch() {
    const [active, setActive] = useState('')
    const [isOnlyPrivate, setIsOnlyPrivate] = useState(false)

    useEffect(() => {
        const event = new CustomEvent('master_private_class_switch', {detail: active})
        document.dispatchEvent(event)
    }, [active])

    useEffect(() => {
        const listener = (event) => {
            const menuitem = event.detail
            if(menuitem === 'old') {
                setIsOnlyPrivate(true)
                setActive('private');
            } else {
                setIsOnlyPrivate(false)
            }

        }

        document.addEventListener('privateclass_menu_tabs', listener)

        return () => {
            document.removeEventListener('privateclass_menu_tabs', listener)
        }
    }, []);

    return (
        <MenuContainer>
            {!isOnlyPrivate && (
                <Item
                    isActive={active === ''}
                    onClick={() => setActive('')}
                >Todas</Item>
            )}

            <Item
                isActive={active === 'private'}
                onClick={() => setActive('private')}
            >Clases en directo</Item>
            {!isOnlyPrivate && (
                <Item
                    isActive={active === 'master'}
                    onClick={() => setActive('master')}
                >Clases de consulta</Item>
            )}

        </MenuContainer>
    )
}

const MenuContainer = styled.div`
    display: flex;
    flex-direction: row;
`

const Item = styled.div`
    padding-left: 8px;
    padding-right: 8px;
    font-size: 14px;
    cursor: pointer;
    font-weight: ${props => props.isActive ? 'bold' : 'lighter'};
    color: ${props => props.isActive ? 'white' : '#5F676D'};
`

if (document.getElementsByTagName('master-private-classes-switch')) {
    const elms = document.getElementsByTagName('master-private-classes-switch')

    for (let elm of elms) {
        ReactDOM.render(
            <MasterPrivateClassesSwitch/>,
            elm
        );
    }
}
